import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import resumeData from '../data/resumeData.json';

const Awards = ({ data = resumeData.awards }) => {
  const [lightboxState, setLightboxState] = useState({ open: false, slides: [], index: 0 });

  const openLightbox = (images, index) => {
    setLightboxState({
      open: true,
      slides: images.map((img) => ({ src: img.src, alt: img.alt })),
      index
    });
  };

  const closeLightbox = () => {
    setLightboxState((prev) => ({ ...prev, open: false }));
  };

  return (
    <section className="o-section t-section">
      <div className="o-section__header-bg t-section__header"></div>
      <div className="o-section__content-bg t-section__content"></div>

      <div className="o-container">
        <div className="o-section__container">
          <header className="o-section__header t-section__header">
            <div className="o-content">
              <h2 className="o-section__heading">{data.heading}</h2>
              <div className="o-content__body o-section__description">{data.description}</div>
            </div>
          </header>

          <div className="o-section__content t-section__content">
            <div className="o-grid">
              {(data.items || []).map((award) => {
                const hasImages = Array.isArray(award.images) && award.images.length > 0;

                return (
                  <div className="o-grid__col-md-4 o-grid__col-sm-6" key={award.id}>
                    <div className="o-content">
                      <hr className="c-deco-line t-primary-color-line" />
                      <div className="o-content__body">
                        <h3>{award.title}</h3>
                        <p>{award.description}</p>

                        {hasImages && (
                          <div className="award-thumbnails">
                            {award.images.map((img, idx) => (
                              <button
                                key={idx}
                                type="button"
                                className="award-thumbnail-btn"
                                onClick={() => openLightbox(award.images, idx)}
                                aria-label={`View photo ${idx + 1} of ${award.title}`}
                              >
                                <img
                                  src={img.src}
                                  alt={img.alt}
                                  className="award-thumbnail-img"
                                />
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <Lightbox
        open={lightboxState.open}
        close={closeLightbox}
        slides={lightboxState.slides}
        index={lightboxState.index}
      />

      <style>{`
        .award-thumbnails {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 12px;
        }

        .award-thumbnail-btn {
          border: none;
          padding: 0;
          background: transparent;
          cursor: pointer;
          border-radius: 6px;
          overflow: hidden;
          flex: 0 0 auto;
          transition: opacity 180ms ease, transform 180ms ease;
        }

        .award-thumbnail-btn:hover {
          opacity: 0.85;
          transform: scale(1.03);
        }

        .award-thumbnail-btn:focus-visible {
          outline: 3px solid rgba(25, 117, 209, 0.5);
          outline-offset: 2px;
        }

        .award-thumbnail-img {
          display: block;
          width: 80px;
          height: 60px;
          object-fit: cover;
          border-radius: 6px;
        }
      `}</style>
    </section>
  );
};

export default Awards;
